var profileImgSVG = "/home/circleci/app/src/assets/img/profileImg.svg";

export { profileImgSVG as default };
